namespace Matrix.Indexation {
    export interface IndexRorRow {
        IndexationProfileCode?: string;
        IndexCode?: string;
        BaseDate?: string;
        EffectiveDate?: string;
        SourceCode?: string;
        IndexRor?: number;
        PriceIndex?: number;
        IndexCurrency?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        IndexationProfileName?: string;
        IndexationProfileIndexationInstanceId?: string;
        IndexationProfileEffectiveDate?: string;
        IndexationProfileValidFrom?: string;
        IndexationProfileValidTo?: string;
        IndexationProfileShortName?: string;
        IndexationProfileRowId?: number;
        IndexationProfileDefaultSortOrder?: number;
        IndexName?: string;
        IndexLocalCurrencyCode?: string;
        IndexTypeCode?: string;
        IndexPriceSource1?: string;
        IndexPriceSource1Id?: string;
        IndexPriceSource2?: string;
        IndexPriceSource2Id?: string;
        IndexFxOtherCurrency?: string;
        IndexRowId?: number;
        IndexDefaultSortOrder?: number;
        SourceName?: string;
        SourceSourceGroup?: string;
        SourceSourceCategory?: string;
        SourceSourceId?: number;
        SourceRowId?: number;
        IndexCurrencyName?: string;
        IndexCurrencyRowId?: number;
        IndexCurrencyDefaultSortOrder?: number;
    }

    export namespace IndexRorRow {
        export const idProperty = 'RowId';
        export const localTextPrefix = 'Indexation.IndexRor';
        export const deletePermission = 'DataAdmin:IndexRor';
        export const insertPermission = 'DataAdmin:IndexRor';
        export const readPermission = 'Read:IndexRor';
        export const updatePermission = 'DataAdmin:IndexRor';

        export declare const enum Fields {
            IndexationProfileCode = "IndexationProfileCode",
            IndexCode = "IndexCode",
            BaseDate = "BaseDate",
            EffectiveDate = "EffectiveDate",
            SourceCode = "SourceCode",
            IndexRor = "IndexRor",
            PriceIndex = "PriceIndex",
            IndexCurrency = "IndexCurrency",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            IndexationProfileName = "IndexationProfileName",
            IndexationProfileIndexationInstanceId = "IndexationProfileIndexationInstanceId",
            IndexationProfileEffectiveDate = "IndexationProfileEffectiveDate",
            IndexationProfileValidFrom = "IndexationProfileValidFrom",
            IndexationProfileValidTo = "IndexationProfileValidTo",
            IndexationProfileShortName = "IndexationProfileShortName",
            IndexationProfileRowId = "IndexationProfileRowId",
            IndexationProfileDefaultSortOrder = "IndexationProfileDefaultSortOrder",
            IndexName = "IndexName",
            IndexLocalCurrencyCode = "IndexLocalCurrencyCode",
            IndexTypeCode = "IndexTypeCode",
            IndexPriceSource1 = "IndexPriceSource1",
            IndexPriceSource1Id = "IndexPriceSource1Id",
            IndexPriceSource2 = "IndexPriceSource2",
            IndexPriceSource2Id = "IndexPriceSource2Id",
            IndexFxOtherCurrency = "IndexFxOtherCurrency",
            IndexRowId = "IndexRowId",
            IndexDefaultSortOrder = "IndexDefaultSortOrder",
            SourceName = "SourceName",
            SourceSourceGroup = "SourceSourceGroup",
            SourceSourceCategory = "SourceSourceCategory",
            SourceSourceId = "SourceSourceId",
            SourceRowId = "SourceRowId",
            IndexCurrencyName = "IndexCurrencyName",
            IndexCurrencyRowId = "IndexCurrencyRowId",
            IndexCurrencyDefaultSortOrder = "IndexCurrencyDefaultSortOrder"
        }
    }
}
